import type {
  JsonObject,
  ValidateMasterLockDeviceResponse,
} from '@/app-package';
import axios from 'axios';

export type ValidateMasterLockDevice =
  JsonObject<ValidateMasterLockDeviceResponse>;

const validateMasterlockDevice = async (
  deviceId: string,
  listingId: string,
) => {
  const { data } = await axios.get<ValidateMasterLockDevice>(
    `/appointment/masterlock/validate/${deviceId}?listingId=${listingId}`,
  );
  return data;
};

export default validateMasterlockDevice;
